import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2747964"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "passengers" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Select passenger(s)", -1))
const _hoisted_3 = {
  key: 0,
  class: "input-field__error"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "documents" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InsurancePassenger = _resolveComponent("InsurancePassenger")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["option", {active: _ctx.active}]),
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectInsurance()))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passengers, (passenger, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createVNode(_component_InsurancePassenger, {
              index: index,
              passenger: passenger
            }, null, 8, ["index", "passenger"])
          ]))
        }), 128)),
        _createElementVNode("li", null, [
          _createVNode(_component_BaseCheckbox, {
            id: `confirm-insurance-${_ctx.insuranceType}`,
            name: `confirm-insurance-${_ctx.insuranceType}`,
            label: _ctx.$t('checkout.insurance.InformationProvided'),
            modelValue: _ctx.informationProvidedInput,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.informationProvidedInput) = $event))
          }, null, 8, ["id", "name", "label", "modelValue"])
        ])
      ])
    ]),
    (_ctx.v$.$errors.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.$errors, (error) => {
            return (_openBlock(), _createElementBlock("li", {
              key: error,
              innerHTML: error.$message
            }, null, 8, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
        return (_openBlock(), _createElementBlock("li", {
          key: document.name
        }, [
          _createElementVNode("a", {
            href: document.url,
            target: "_blank"
          }, _toDisplayString(document.name), 9, _hoisted_6)
        ]))
      }), 128))
    ])
  ], 2))
}